import { Injectable, inject } from '@angular/core';
import { ofType, createEffect, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { map } from 'rxjs/operators';

import { ActionTypes, OtherAction } from './actions';
import { AppState } from '../shared/models/shared.model';
import { CustomerSearchService } from '../shared/services/customer-search.service';

@Injectable()
export class AppEffects {
  protected store = inject<Store<AppState>>(Store);
  protected actions$ = inject(Actions);
  protected customerSearchService = inject(CustomerSearchService);

  init$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActionTypes.SomeAction),
      map((_) => new OtherAction()),
    ),
  );
}
